import { render, staticRenderFns } from "./EmailUsSubmitted.vue?vue&type=template&id=4aaadb58&scoped=true"
import script from "./EmailUsSubmitted.vue?vue&type=script&lang=js"
export * from "./EmailUsSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaadb58",
  null
  
)

export default component.exports